import { useMutation } from "react-query";
import * as auth from "services/authServices/AuthServices";

export const useAppLogin = () => {
  return useMutation((formData) => auth.appLogin(formData));
};

export const useGetOtp = () => {
  return useMutation((formData) => auth.getOtp(formData));
};

export const useVerifyOtp = () => {
  return useMutation((formData) => auth.verifyOtp(formData));
};

export const useSetpassword = () => {
  return useMutation((formData) => auth.setPassword(formData));
};

export const useContact = () => {
  return useMutation((formData) => auth.contact(formData));
};